var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1rem", "padding-bottom": "1rem" } },
    [
      _c("topbar", { attrs: { text: "开心一刻", status: true } }),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.detail.smileTitle))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm._f("time")(_vm.detail.createTime)))
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.detail.content) }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1011a4a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1011a4a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/jokeDetail.vue
// module id = null
// module chunks = 